<template>
  <ul id="a-language" data-cta>
    <li>
      <a class="language-it" :class="{ 'is-active': lang === 'it' }" href="/it/">
        <u>It.</u>
      </a>
    </li>
    <li>
      <a class="language-en" :class="{ 'is-active': lang === 'en' }" href="/en/">
        <u>En</u>
      </a>
    </li>
  </ul>
</template>

<script>
import { app } from '@/utils/store';

export default {
  data() {
    return {
      lang: app.language,
    };
  },
};
</script>
